import React from "react";
import Typography from "@material-ui/core/Typography";
import DateFormat from "../../../util/date-format";
import { useGameContextContext } from "../../../state/game-context/context";
import gameClockViewStyles from "../styles/GameClockView.styles";
import { toDisplayMs } from "./utils/PlayUtils";

const GameClockView = ({ size }) => {
	const classes = gameClockViewStyles({ size });

	const { state: gameContextState } = useGameContextContext();
	const gameClock = gameContextState.gameClock();
	const gameConfig = gameContextState.gameConfig();

	// gameClock is a revived Clock instance (ManualGameClock or GameClock).
	// Both implement now() returning the current effective game time in ms.
	let timeMs = 0;
	if (gameClock && typeof gameClock.now === "function") {
		timeMs = gameClock.now();
	} else if (typeof gameClock?.now === "number") {
		timeMs = gameClock.now;
	}

	// Stored time is canonical countdown; ascending Clock Type only flips
	// the rendered value.
	return (
		<Typography variant="inherit" className={classes.clockText}>
			{DateFormat.formatMilliseconds(toDisplayMs(timeMs, gameConfig), "mm:ss")}
		</Typography>
	);
};

export default GameClockView;
